// import { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import axios from "axios";

// const HospitalServiceModal = ({ isOpen, onClose, onSave, serviceToEdit }) => {
//   const isEditMode = !!serviceToEdit;
//   const [serviceData, setServiceData] = useState({
//     serviceName: isEditMode ? serviceToEdit?.serviceName || "" : "",
//     particulars: isEditMode ? serviceToEdit?.particulars || "" : "",
//     providedBy: isEditMode ? serviceToEdit?.providedBy || "" : "",
//     unitPrice: isEditMode ? (serviceToEdit?.unitPrice != null ? serviceToEdit.unitPrice.toString() : "") : "",
//   });
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       setServiceData({
//         serviceName: isEditMode ? serviceToEdit?.serviceName || "" : "",
//         particulars: isEditMode ? serviceToEdit?.particulars || "" : "",
//         providedBy: isEditMode ? serviceToEdit?.providedBy || "" : "",
//         unitPrice: isEditMode ? (serviceToEdit?.unitPrice != null ? serviceToEdit.unitPrice.toString() : "") : "",
//       });
//       setErrors({});
//     }
//   }, [isOpen, serviceToEdit]);

//   const validateForm = () => {
//     const newErrors = {};
//     let hasError = false;

//     // Strict validation for add mode (POST requires all fields)
//     if (!isEditMode) {
//       if (!serviceData.serviceName.trim()) {
//         newErrors.serviceName = "Service Name is required";
//         hasError = true;
//       }
//       if (!serviceData.particulars.trim()) {
//         newErrors.particulars = "Particulars is required";
//         hasError = true;
//       }
//       if (!serviceData.providedBy.trim()) {
//         newErrors.providedBy = "Provided By is required";
//         hasError = true;
//       }
//       if (!serviceData.unitPrice.trim()) {
//         newErrors.unitPrice = "Unit Price is required";
//         hasError = true;
//       } else if (isNaN(serviceData.unitPrice) || Number(serviceData.unitPrice) <= 0) {
//         newErrors.unitPrice = "Unit Price must be a positive number";
//         hasError = true;
//       }
//     }

//     // In edit mode, ensure at least one field is provided (PUT requirement)
//     if (isEditMode) {
//       const hasChanges =
//         serviceData.serviceName.trim() ||
//         serviceData.particulars.trim() ||
//         serviceData.providedBy.trim() ||
//         serviceData.unitPrice.trim();
//       if (!hasChanges) {
//         newErrors.form = "At least one field must be provided to update";
//         hasError = true;
//       } else if (serviceData.unitPrice.trim() && (isNaN(serviceData.unitPrice) || Number(serviceData.unitPrice) <= 0)) {
//         newErrors.unitPrice = "Unit Price must be a positive number";
//         hasError = true;
//       }
//     }

//     setErrors(newErrors);
//     if (hasError) {
//       toast.error(newErrors.form || "Please fix the errors in the form", {
//         position: "top-right",
//         autoClose: 3000,
//       });
//     }
//     return !hasError;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setServiceData((prevData) => ({ ...prevData, [name]: value }));
//     if (value.trim() || !isEditMode) {
//       setErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[name];
//         delete newErrors.form;
//         return newErrors;
//       });
//     }
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;

//     setIsLoading(true);
//     try {
//       let savedService;
//       if (isEditMode) {
//         // For edit mode, call PUT API with only provided fields
//         const payload = {};
//         if (serviceData.serviceName.trim()) payload.serviceName = serviceData.serviceName.trim();
//         if (serviceData.particulars.trim()) payload.particulars = serviceData.particulars.trim();
//         if (serviceData.providedBy.trim()) payload.providedBy = serviceData.providedBy.trim();
//         if (serviceData.unitPrice.trim()) payload.unitPrice = parseFloat(serviceData.unitPrice);

//         // console.log("PUT request payload:", payload); // Debug payload
//         const response = await axios.put(
//           `https://api.muktihospital.com/api/hospital/service/edit/${serviceToEdit.id}`,
//           payload,
//           {
//             headers: {
//               "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079",
//             },
//           }
//         );
//         // console.log("PUT response:", response.data); // Debug response
//         savedService = {
//           id: serviceToEdit.id,
//           serviceName: response.data.service.serviceName || serviceData.serviceName.trim() || "",
//           particulars: response.data.service.particulars || serviceData.particulars.trim() || "",
//           providedBy: response.data.service.providedBy || serviceData.providedBy.trim() || "",
//           unitPrice: response.data.service.unitPrice || parseFloat(serviceData.unitPrice) || "",
//         };
//         // console.log("Saved service:", savedService); // Debug savedService
//         toast.success("Service updated successfully!", {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       } else {
//         // For add mode, call POST API
//         const payload = {
//           serviceName: serviceData.serviceName.trim(),
//           particulars: serviceData.particulars.trim(),
//           providedBy: serviceData.providedBy.trim(),
//           unitPrice: parseFloat(serviceData.unitPrice),
//         };
//         // console.log("POST request payload:", payload); // Debug payload
//         const response = await axios.post(
//           "https://api.muktihospital.com/api/hospital/service/add",
//           payload,
//           {
//             headers: {
//               "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079",
//             },
//           }
//         );
//         // console.log("POST response:", response.data); // Debug response
//         savedService = {
//           id: response.data.service.id || Math.random().toString(36).substr(2, 9),
//           serviceName: response.data.service.serviceName || serviceData.serviceName.trim(),
//           particulars: response.data.service.particulars || serviceData.particulars.trim(),
//           providedBy: response.data.service.providedBy || serviceData.providedBy.trim(),
//           unitPrice: response.data.service.unitPrice || parseFloat(serviceData.unitPrice),
//         };
//         // console.log("Saved service:", savedService); // Debug savedService
//         toast.success("Service added successfully!", {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       }
//       onSave(savedService, isEditMode);
//       onClose();
//     } catch (error) {
//       console.error("Error saving service:", error);
//       if (error.response?.status === 409) {
//         toast.error("A service with this name already exists. Please choose a unique name.", {
//           position: "top-right",
//           autoClose: 5000,
//         });
//       } else if (error.response?.status === 400) {
//         toast.error(error.response.data.error || "Missing or invalid service fields.", {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       } else if (error.response?.status === 404) {
//         toast.error("Service not found.", {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       } else {
//         toast.error("Failed to save service.", {
//           position: "top-right",
//           autoClose: 3000,
//         });
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 print-hidden">
//       <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[100vh] overflow-y-auto">
//         <div className="p-4 sm:p-6 border-b border-gray-200">
//           <h2 className="text-lg sm:text-xl font-bold text-gray-700">{isEditMode ? "Edit Service" : "Add Service"}</h2>
//         </div>
//         <div className="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Service Name <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
//             </label>
//             <input
//               type="text"
//               name="serviceName"
//               value={serviceData.serviceName}
//               onChange={handleChange}
//               className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
//                 errors.serviceName ? "border-red-500" : ""
//               }`}
//               placeholder="Enter service name"
//               disabled={isLoading}
//             />
//             {errors.serviceName && (
//               <span className="text-red-500 text-xs mt-1">{errors.serviceName}</span>
//             )}
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Particulars <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
//             </label>
//             <input
//               type="text"
//               name="particulars"
//               value={serviceData.particulars}
//               onChange={handleChange}
//               className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
//                 errors.particulars ? "border-red-500" : ""
//               }`}
//               placeholder="Enter particulars"
//               disabled={isLoading}
//             />
//             {errors.particulars && (
//               <span className="text-red-500 text-xs mt-1">{errors.particulars}</span>
//             )}
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Provided By <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
//             </label>
//             <input
//               type="text"
//               name="providedBy"
//               value={serviceData.providedBy}
//               onChange={handleChange}
//               className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
//                 errors.providedBy ? "border-red-500" : ""
//               }`}
//               placeholder="Enter provider name"
//               disabled={isLoading}
//             />
//             {errors.providedBy && (
//               <span className="text-red-500 text-xs mt-1">{errors.providedBy}</span>
//             )}
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Unit Price <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
//             </label>
//             <input
//               type="text"
//               name="unitPrice"
//               value={serviceData.unitPrice}
//               onChange={handleChange}
//               className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
//                 errors.unitPrice ? "border-red-500" : ""
//               }`}
//               placeholder="Enter unit price"
//               disabled={isLoading}
//             />
//             {errors.unitPrice && (
//               <span className="text-red-500 text-xs mt-1">{errors.unitPrice}</span>
//             )}
//           </div>
//         </div>
//         <div className="flex flex-col sm:flex-row justify-end gap-3 p-4 sm:p-6 border-t border-gray-200">
//           <button
//             onClick={onClose}
//             className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300"
//             disabled={isLoading}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200"
//             disabled={isLoading}
//           >
//             {isLoading ? "Saving..." : "Save"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HospitalServiceModal;

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

const HospitalServiceModal = ({ isOpen, onClose, onSave, serviceToEdit }) => {
  const isEditMode = !!serviceToEdit;
  
  // 1. UPDATE: Removed particulars & providedBy from state
  const [serviceData, setServiceData] = useState({
    serviceName: isEditMode ? serviceToEdit?.serviceName || "" : "",
    unitPrice: isEditMode ? (serviceToEdit?.unitPrice != null ? serviceToEdit.unitPrice.toString() : "") : "",
  });
  
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // 2. UPDATE: Removed from useEffect reset
  useEffect(() => {
    if (isOpen) {
      setServiceData({
        serviceName: isEditMode ? serviceToEdit?.serviceName || "" : "",
        unitPrice: isEditMode ? (serviceToEdit?.unitPrice != null ? serviceToEdit.unitPrice.toString() : "") : "",
      });
      setErrors({});
    }
  }, [isOpen, serviceToEdit, isEditMode]);

  const validateForm = () => {
    const newErrors = {};
    let hasError = false;

    // 3. UPDATE: Removed validation for particulars & providedBy
    if (!isEditMode) {
      if (!serviceData.serviceName.trim()) {
        newErrors.serviceName = "Service Name is required";
        hasError = true;
      }
      if (!serviceData.unitPrice.trim()) {
        newErrors.unitPrice = "Unit Price is required";
        hasError = true;
      } else if (isNaN(serviceData.unitPrice) || Number(serviceData.unitPrice) <= 0) {
        newErrors.unitPrice = "Unit Price must be a positive number";
        hasError = true;
      }
    }

    // In edit mode
    if (isEditMode) {
      const hasChanges =
        serviceData.serviceName.trim() ||
        serviceData.unitPrice.trim();
        
      if (!hasChanges) {
        newErrors.form = "At least one field must be provided to update";
        hasError = true;
      } else if (serviceData.unitPrice.trim() && (isNaN(serviceData.unitPrice) || Number(serviceData.unitPrice) <= 0)) {
        newErrors.unitPrice = "Unit Price must be a positive number";
        hasError = true;
      }
    }

    setErrors(newErrors);
    if (hasError) {
      toast.error(newErrors.form || "Please fix the errors in the form", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    return !hasError;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceData((prevData) => ({ ...prevData, [name]: value }));
    if (value.trim() || !isEditMode) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        delete newErrors.form;
        return newErrors;
      });
    }
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      let savedService;
      
      // 4. UPDATE: Removed fields from API payloads
      if (isEditMode) {
        // --- EDIT MODE ---
        const payload = {};
        if (serviceData.serviceName.trim()) payload.serviceName = serviceData.serviceName.trim();
        if (serviceData.unitPrice.trim()) payload.unitPrice = parseFloat(serviceData.unitPrice);

        const response = await axios.put(
          `https://api.muktihospital.com/api/hospital/service/edit/${serviceToEdit.id}`,
          payload,
          {
            headers: {
              "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079",
            },
          }
        );
        
        savedService = {
          id: serviceToEdit.id,
          serviceName: response.data.service.serviceName || serviceData.serviceName.trim() || "",
          unitPrice: response.data.service.unitPrice || parseFloat(serviceData.unitPrice) || "",
        };
        
        toast.success("Service updated successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        // --- ADD MODE ---
        const payload = {
          serviceName: serviceData.serviceName.trim(),
          unitPrice: parseFloat(serviceData.unitPrice),
        };
        
        const response = await axios.post(
          "https://api.muktihospital.com/api/hospital/service/add",
          payload,
          {
            headers: {
              "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079",
            },
          }
        );
        
        savedService = {
          id: response.data.service.id,
          serviceName: response.data.service.serviceName || serviceData.serviceName.trim(),
          unitPrice: response.data.service.unitPrice || parseFloat(serviceData.unitPrice),
        };
        
        toast.success("Service added successfully!", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      onSave(savedService, isEditMode);
      onClose();
    } catch (error) {
      console.error("Error saving service:", error);
      if (error.response?.status === 409) {
        toast.error("A service with this name already exists.", { position: "top-right", autoClose: 5000 });
      } else if (error.response?.status === 400) {
        toast.error(error.response.data.error || "Missing fields.", { position: "top-right", autoClose: 3000 });
      } else if (error.response?.status === 404) {
        toast.error("Service not found.", { position: "top-right", autoClose: 3000 });
      } else {
        toast.error("Failed to save service.", { position: "top-right", autoClose: 3000 });
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 print-hidden">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[100vh] overflow-y-auto">
        <div className="p-4 sm:p-6 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl font-bold text-gray-700">{isEditMode ? "Edit Service" : "Add Service"}</h2>
        </div>
        
        <div className="p-4 sm:p-6 grid gap-4">
          
          {/* Service Name Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Service Name <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
            </label>
            <input
              type="text"
              name="serviceName"
              value={serviceData.serviceName}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
                errors.serviceName ? "border-red-500" : ""
              }`}
              placeholder="Enter service name"
              disabled={isLoading}
            />
            {errors.serviceName && (
              <span className="text-red-500 text-xs mt-1">{errors.serviceName}</span>
            )}
          </div>

          {/* 5. UPDATE: Removed Inputs for Particulars & Provided By */}

          {/* Unit Price Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Unit Price <span className="text-red-500">{!isEditMode ? "*" : ""}</span>
            </label>
            <input
              type="text"
              name="unitPrice"
              value={serviceData.unitPrice}
              onChange={handleChange}
              className={`w-full p-2 border rounded-md outline-none focus:ring-0 text-sm text-gray-700 ${
                errors.unitPrice ? "border-red-500" : ""
              }`}
              placeholder="Enter unit price"
              disabled={isLoading}
            />
            {errors.unitPrice && (
              <span className="text-red-500 text-xs mt-1">{errors.unitPrice}</span>
            )}
          </div>

        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-3 p-4 sm:p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="bg-[#E7633D]/90 text-sm text-white py-2 px-6 rounded-md hover:bg-[#E7633D] transition-all duration-300"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-M-primary-color/90 text-sm text-white py-2 px-6 rounded-md hover:bg-M-primary-color transition-all duration-200"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HospitalServiceModal;